export const ugovor_dopunski_rad_pravilnik = {
  templateId: 5.3,
  category: 11,
  templateTitle: "Ugovor o dopunskom radu",
  templateDescription: `</p>Pod određenim uvjetima, radnik koji radi u punom radnom vremenu (kod jednog ili više poslodavaca), može sklopiti ugovor o dopunskom radu s drugim poslodavcem.</p>`,
  description: `
  <h5>OPIS I SVRHA DOKUMENTA</h5>
  <p>Radnik koji radi u punom radnom vremenu može sklopiti ugovor o dopunskom radu s drugim poslodavcem, pod uvjetima određenim Zakonom o radu.</p>
  <p>Za dopunski rad postoje određena ograničenja:</p>
  <li> tjedno ograničenje - može trajati najviše do 8 sati tjedno,</li>
  <li> godišnje ograničenje - može trajati najviše do 180 sati godišnje.</li>
  <br> 
  <p>Dodatno se ističe da je moguć samo dopunski rad radnika koji radi u punom radnom vremenu - 40 sati tjedno.  </p>
  <p>Nužna zakonska pretpostavka za sklapanje ugovora o dopunskom radu s drugim poslodavcem (ili svakim poslodavcem, ako radnik ima više poslodavaca) je izdavanje suglasnosti za takav rad od strane poslodav(a)ca kod kojeg radnik radi na temelju ugovora o radu na puno ili nepuno radno vrijeme.</p>
  <p>Primjer dopisa kojim poslodavac daje takvu suglasnost možete pogledati i izraditi <a class="local-link" href="/contract?template=77">ovdje</a>.</p>
  <p>Ukoliko radnik ima više poslodavaca kod kojih kumulativno radi u punom radnom vremenu od 40 sati tjedno, potrebno je da svi poslodavci s kojima radnik već prethodno ima sklopljen ugovor o radu daju pisanu suglasnost, bez obzira u kojem radnom vremenu radi kod njih i bez obzira da li je u radnom odnosu na određeno ili neodređeno vrijeme.</p>
  <p>Također, poslodavac koji je dao radniku suglasnost za dopunski rad može tu suglasnost „povući“, a ne mora istu niti dati.</p>
  <p>Važno je naglasiti da radnik ne može sklopiti ugovor o dopunskom radu s poslodavcem s kojim je u tom trenutku u radnom odnosu, bez obzira na trajanje radnog vremena kod istoga.</p>
  <p>U praksi se, gotovo u pravilu, ugovor o dopunskom radu sklapa na određeno vrijeme, no nema zakonske prepreke da se ugovor o dopunskom radu ne sklopi i na neodređeno vrijeme. </p>
  <p>Radnik može sklopiti dva i više ugovora o dopunskom radu s različitim poslodavcima istovremeno, ali u granicama koje propisuje Zakon o radu (8 sati tjedno odnosno 180 sati godišnje).</p>
  <p>Za dopunski rad radnik ima pravo na plaću (plaća se isplaćuje uz uplatu doprinosa, poreza i prireza), na godišnji odmor, ali i druga prava koja mu pripadaju sukladno zakonu o radu, pravilniku o radu, kolektivnom ugovoru i sl..</p>
  <p>Prikazani primjerak ugovora u radu zaključuje se između poslodavca i radnika u slučaju da je kod poslodavca donesen pravilnik o radu te kad se na radni odnos ne primjenjuju odredbe određenog kolektivnog ugovora.</p>

  <h5>PRAVNA OSNOVA</h5>
    <p>Zakon o radu, Pravilnik o radu.</p>
  `,

  sides: [
    {
      prefix: "Na temelju odredaba Zakona o radu i Pravilnika o radu,",
      signature: "Za Poslodavca:",
      inputs: [{
        type: "input",
        required: true,
        placeholder: "Poslovni subjekt",
      },
      {
        type: "input",
        required: true,
        placeholder: "Ulica i kućni broj",
      },
      {
        type: "input",
        required: true,
        placeholder: "Mjesto",
      },
      {
        type: "input",
        required: true,
        placeholder: "OIB",
      },
      {
        type: "input",
        placeholder: "Zastupa",
        inSignature: true,
      },
      {
        type: "input",
        placeholder: "Funkcija",
        inSignature: true,
      }],
      suffix: " (u daljnjem tekstu: Poslodavac)",
      delimiter: `i`
    },
    {
      signature: "Radnik:",
      inputs: [{
        type: "input",
        required: true,
        placeholder: "Ime i prezime",
        label: "Ime i prezime",
        inSignature: true,
      },
      {
        type: "input",
        required: true,
        placeholder: "Ulica i kućni broj",
      },
      {
        type: "input",
        required: true,
        placeholder: "Mjesto",
      },
      {
        type: "input",
        required: true,
        placeholder: "OIB",
      },
      ],
      suffix: " (u daljnjem tekstu: Radnik),"
    }
  ],

  headline: "zaključuju sljedeći",
  title: "UGOVOR O DOPUNSKOM RADU",

  articles: [
    {
      title: "VRSTA UGOVORA",
      mandatory: true,
      statements: [
        {
          type: "text",
          mandatory: true,
          editable: false,
          content: "Ovim Ugovorom, zasniva se radni odnos između Poslodavca i Radnika prema kojemu će Radnik za Poslodavca posao obavljati u dopunskom radu.",
          value: "",
        },
      ]
    },
    {
      title: "PRETHODNA SUGLASNOST",
      mandatory: true,
      statements: [
        {
          type: "choice",
          mandatory: true,
          editable: false,
          choices: [
            {
              parts: [
                { type: "text", content: "Za obavljanje poslova iz ovog Ugovora, Radniku je poslodavac" },
                { type: "input", value: "", required: true, help: "Ukoliko radnik ima trenutno jednog poslodavca, ovdje unosite podatke poslodavca radnika." },
                { type: "text", content: ", kod kojega Radnik radi u punom radnom vremenu, izdao prethodnu pisanu suglasnost koja se nalazi u privitku ovog Ugovora i čini njegov sastavni dio.                " },
              ]
            },
            {
              parts: [
                { type: "text", content: "Za obavljanje poslova iz ovog Ugovora, poslodavci" },
                { type: "input", value: "", required: true, help: "Ukoliko radnik ima trenutno više od jednog poslodavca, ovdje unosite podatke poslodavaca radnika." },
                { type: "text", content: ", kod kojih Radnik ukupno radi u punom radnom vremenu, izjavili su prethodne pisane suglasnosti koje se nalaze u privitku ovog Ugovora i čine njegov sastavni dio.                " },
              ]
            }],
          value: "",
        }
      ]
    },
    {
      title: "TRAJANJE UGOVORA",
      mandatory: true,
      exampleContent: true,
      statements: [
        {
          type: "choice",
          mandatory: true,
          editable: false,
          choices: [
            {
              parts: [
                { type: "text", content: "Ovim se Ugovorom između Poslodavca i Radnika zasniva radni odnos na određeno vrijeme za obavljanje poslova na radnom mjestu navedenom u ovom Ugovoru,  uslijed povećane potrebe za poljoprivrednim radovima u proizvodnoj sezoni ratarskih kultura roda" },
                { type: "input", value: "", required: true },
                { type: "text", content: "godine, a koji poslovi traju najkasnije do" },
                { type: "input", value: "", required: true },
                { type: "text", content: "godine.", help: "Za uzastopne ugovore o radu (drugi i svaki sljedeći) na određeno vrijemo mora biti naveden objektivni razlog sklapanja ugovora (prestanak unaprijed određen rokom, izvršenjem određenog posla ili nastupanjem određenog događaja) te isti mora biti osnovan i dokaziv. Iako sklapanje prvog ugovora o radu na određeno vrijeme bez navođenja objektivnog razloga nije prekršaj, radi izbjegavanja sporova radnika i poslodavca te mogućih raznih tumačenja inspekcijskih tijela, predlaže se i u prvom ugovoru o radu na određeno vrijeme navesti objektivni razlog za sklapanje ugovora o radu na određeno vrijeme. Ukoliko ugovor o radu nije sklopljen do točno određenog dana prijedlog je da se prije trenutka kada će prestati potreba za obavljanjem poslova, radniku uruči Obavijest o prestanku potrebe za radom radnika na temelju koje će radni odnos radnika prestati – navedena obavijest se ne smatra otkazom ugovora o radu!" },
              ]
            },
            {
              parts: [
                { type: "text", content: "Ovim se Ugovorom između Poslodavca i Radnika zasniva radni odnos na određeno vrijeme za obavljanje poslova na radnom mjestu navedenom u ovom Ugovoru,  uslijed povećane potrebe za radom tijekom trajanja ljetne turističke sezone" },
                { type: "input", value: "", required: true },
                { type: "text", content: "godine, a koji poslovi traju najkasnije do" },
                { type: "input", value: "", required: true },
                { type: "text", content: "godine.", help: "Za uzastopne ugovore o radu (drugi i svaki sljedeći) na određeno vrijemo mora biti naveden objektivni razlog sklapanja ugovora (prestanak unaprijed određen rokom, izvršenjem određenog posla ili nastupanjem određenog događaja) te isti mora biti osnovan i dokaziv. Iako sklapanje prvog ugovora o radu na određeno vrijeme bez navođenja objektivnog razloga nije prekršaj, radi izbjegavanja sporova radnika i poslodavca te mogućih raznih tumačenja inspekcijskih tijela, predlaže se i u prvom ugovoru o radu na određeno vrijeme navesti objektivni razlog za sklapanje ugovora o radu na određeno vrijeme. Ukoliko ugovor o radu nije sklopljen do točno određenog dana prijedlog je da se prije trenutka kada će prestati potreba za obavljanjem poslova, radniku uruči Obavijest o prestanku potrebe za radom radnika na temelju koje će radni odnos radnika prestati – navedena obavijest se ne smatra otkazom ugovora o radu!" },
              ]
            },
            {
              parts: [
                { type: "text", content: "Ovim se Ugovorom između Poslodavca i Radnika zasniva radni odnos na određeno vrijeme za obavljanje poslova na radnom mjestu navedenom u ovom Ugovoru,  uslijed povećane potrebe za radom uzrokavane novim narudžbama sljedećih kupaca" },
                { type: "input", value: "", required: true },
                { type: "text", content: ", a koji poslovi traju najkasnije do" },
                { type: "input", value: "", required: true },
                { type: "text", content: "godine.", help: "Za uzastopne ugovore o radu (drugi i svaki sljedeći) na određeno vrijemo mora biti naveden objektivni razlog sklapanja ugovora (prestanak unaprijed određen rokom, izvršenjem određenog posla ili nastupanjem određenog događaja) te isti mora biti osnovan i dokaziv. Iako sklapanje prvog ugovora o radu na određeno vrijeme bez navođenja objektivnog razloga nije prekršaj, radi izbjegavanja sporova radnika i poslodavca te mogućih raznih tumačenja inspekcijskih tijela, predlaže se i u prvom ugovoru o radu na određeno vrijeme navesti objektivni razlog za sklapanje ugovora o radu na određeno vrijeme. Ukoliko ugovor o radu nije sklopljen do točno određenog dana prijedlog je da se prije trenutka kada će prestati potreba za obavljanjem poslova, radniku uruči Obavijest o prestanku potrebe za radom radnika na temelju koje će radni odnos radnika prestati – navedena obavijest se ne smatra otkazom ugovora o radu!" },
              ]
            },
            {
              parts: [
                { type: "text", content: "Ovim se Ugovorom između Poslodavca i Radnika zasniva radni odnos na određeno vrijeme za obavljanje poslova na radnom mjestu navedenom u ovom Ugovoru, uslijed sezone izlova plave ribe,  a koji poslovi traju najkasnije do" },
                { type: "input", value: "", required: true },
                { type: "text", content: "godine.", help: "Za uzastopne ugovore o radu (drugi i svaki sljedeći) na određeno vrijemo mora biti naveden objektivni razlog sklapanja ugovora (prestanak unaprijed određen rokom, izvršenjem određenog posla ili nastupanjem određenog događaja) te isti mora biti osnovan i dokaziv. Iako sklapanje prvog ugovora o radu na određeno vrijeme bez navođenja objektivnog razloga nije prekršaj, radi izbjegavanja sporova radnika i poslodavca te mogućih raznih tumačenja inspekcijskih tijela, predlaže se i u prvom ugovoru o radu na određeno vrijeme navesti objektivni razlog za sklapanje ugovora o radu na određeno vrijeme. Ukoliko ugovor o radu nije sklopljen do točno određenog dana prijedlog je da se prije trenutka kada će prestati potreba za obavljanjem poslova, radniku uruči Obavijest o prestanku potrebe za radom radnika na temelju koje će radni odnos radnika prestati – navedena obavijest se ne smatra otkazom ugovora o radu!" },
              ]
            },
            {
              parts: [
                { type: "text", content: "Ovim se Ugovorom između Poslodavca i Radnika zasniva radni odnos na određeno vrijeme za obavljanje poslova na radnom mjestu navedenom u ovom Ugovoru, do povratka na posao djelatnika zaposlenom na radnom mjestu" },
                { type: "input", value: "", required: true },
                { type: "text", content: ", a koji je privremeno nenazočan uslijed privremene nesposobnosti za rad.", help: "Za uzastopne ugovore o radu (drugi i svaki sljedeći) na određeno vrijemo mora biti naveden objektivni razlog sklapanja ugovora (prestanak unaprijed određen rokom, izvršenjem određenog posla ili nastupanjem određenog događaja) te isti mora biti osnovan i dokaziv. Iako sklapanje prvog ugovora o radu na određeno vrijeme bez navođenja objektivnog razloga nije prekršaj, radi izbjegavanja sporova radnika i poslodavca te mogućih raznih tumačenja inspekcijskih tijela, predlaže se i u prvom ugovoru o radu na određeno vrijeme navesti objektivni razlog za sklapanje ugovora o radu na određeno vrijeme. Ukoliko ugovor o radu nije sklopljen do točno određenog dana prijedlog je da se prije trenutka kada će prestati potreba za obavljanjem poslova, radniku uruči Obavijest o prestanku potrebe za radom radnika na temelju koje će radni odnos radnika prestati – navedena obavijest se ne smatra otkazom ugovora o radu!" },
              ]
            },
            {
              parts: [
                { type: "text", content: "Ovim se Ugovorom između Poslodavca i Radnika zasniva radni odnos na određeno vrijeme za obavljanje poslova na radnom mjestu navedenom u ovom Ugovoru, do povratka na posao djelatnika zaposlenom na radnom mjestu" },
                { type: "input", value: "", required: true },
                { type: "text", content: ", a koji je privremeno nenazočan uslijed korištenja rodiljnog/roditeljskog dopusta.", help: "Za uzastopne ugovore o radu (drugi i svaki sljedeći) na određeno vrijemo mora biti naveden objektivni razlog sklapanja ugovora (prestanak unaprijed određen rokom, izvršenjem određenog posla ili nastupanjem određenog događaja) te isti mora biti osnovan i dokaziv. Iako sklapanje prvog ugovora o radu na određeno vrijeme bez navođenja objektivnog razloga nije prekršaj, radi izbjegavanja sporova radnika i poslodavca te mogućih raznih tumačenja inspekcijskih tijela, predlaže se i u prvom ugovoru o radu na određeno vrijeme navesti objektivni razlog za sklapanje ugovora o radu na određeno vrijeme. Ukoliko ugovor o radu nije sklopljen do točno određenog dana prijedlog je da se prije trenutka kada će prestati potreba za obavljanjem poslova, radniku uruči Obavijest o prestanku potrebe za radom radnika na temelju koje će radni odnos radnika prestati – navedena obavijest se ne smatra otkazom ugovora o radu!" },
              ]
            },
            {
              parts: [
                { type: "text", content: "Ovim se Ugovorom između Poslodavca i Radnika zasniva radni odnos na određeno vrijeme za obavljanje poslova na radnom mjestu navedenom u ovom Ugovoru,  uslijed povećane potrebe rada vezane za pripremu strojeva i proizvodnog pogona uzrokovanih povećanjem proizvodnje u proizvodnoj sezoni" },
                { type: "input", value: "", required: true },
                { type: "text", content: "godine, a koji poslovi traju najkasnije do" },
                { type: "input", value: "", required: true },
                { type: "text", content: "godine.", help: "Za uzastopne ugovore o radu (drugi i svaki sljedeći) na određeno vrijemo mora biti naveden objektivni razlog sklapanja ugovora (prestanak unaprijed određen rokom, izvršenjem određenog posla ili nastupanjem određenog događaja) te isti mora biti osnovan i dokaziv. Iako sklapanje prvog ugovora o radu na određeno vrijeme bez navođenja objektivnog razloga nije prekršaj, radi izbjegavanja sporova radnika i poslodavca te mogućih raznih tumačenja inspekcijskih tijela, predlaže se i u prvom ugovoru o radu na određeno vrijeme navesti objektivni razlog za sklapanje ugovora o radu na određeno vrijeme. Ukoliko ugovor o radu nije sklopljen do točno određenog dana prijedlog je da se prije trenutka kada će prestati potreba za obavljanjem poslova, radniku uruči Obavijest o prestanku potrebe za radom radnika na temelju koje će radni odnos radnika prestati – navedena obavijest se ne smatra otkazom ugovora o radu!" },
              ]
            },
            {
              parts: [
                { type: "text", content: "Ovim se Ugovorom između Poslodavca i Radnika zasniva radni odnos na određeno vrijeme za obavljanje poslova na radnom mjestu navedenom u ovom Ugovoru,  uslijed povećane potrebe za radom radi redovitog remonta" },
                { type: "input", value: "", required: true },
                { type: "text", content: ", a koji poslovi traju najkasnije do" },
                { type: "input", value: "", required: true },
                { type: "text", content: "godine.", help: "Za uzastopne ugovore o radu (drugi i svaki sljedeći) na određeno vrijemo mora biti naveden objektivni razlog sklapanja ugovora (prestanak unaprijed određen rokom, izvršenjem određenog posla ili nastupanjem određenog događaja) te isti mora biti osnovan i dokaziv. Iako sklapanje prvog ugovora o radu na određeno vrijeme bez navođenja objektivnog razloga nije prekršaj, radi izbjegavanja sporova radnika i poslodavca te mogućih raznih tumačenja inspekcijskih tijela, predlaže se i u prvom ugovoru o radu na određeno vrijeme navesti objektivni razlog za sklapanje ugovora o radu na određeno vrijeme. Ukoliko ugovor o radu nije sklopljen do točno određenog dana prijedlog je da se prije trenutka kada će prestati potreba za obavljanjem poslova, radniku uruči Obavijest o prestanku potrebe za radom radnika na temelju koje će radni odnos radnika prestati – navedena obavijest se ne smatra otkazom ugovora o radu!" },
              ]
            },
          {
            parts: [
              { type: "text", content: "Ovim se Ugovorom između Poslodavca i Radnika zasniva radni odnos na određeno vrijeme za obavljanje poslova na radnom mjestu navedenom u ovom Ugovoru, uslijed:" },
              { type: "textarea", content: "" },
              { help: 'S obzirom na gore prikazane primjere rokova ili događaja odnosno objektivnih razloga za sklapanje ugovora o radu na određeno, ovdje samostalno upisujete prethodno navedeno - objektivni razlog sklapanja ugovora.'}
            ]
          }
        ],
        value: "",
      },
    ]
  },  
  {
    title: "PROBNI RAD",
    mandatory: false,
    exampleContent: true,
    statements: [
      {
        type: "text",
        mandatory: true,
        editable: true,
        content: "Ugovorne strane sklapaju ovaj Ugovor uz uvjet probnog rada Radnika u trajanju od šest mjeseci, uz otkazni rok određen Zakonom o radu i Pravilnikom o radu.",
        help: "Probni rad je zakonski dopušten u trajanju od najviše 6 mjeseci.",
      },
    ]
  },
    {
      title: "RADNO MJESTO",
      mandatory: true,
      statements: [
        {
          type: "choice",
          mandatory: true,
          editable: false,
          choices: [
            {
              parts: [
                { type: "text", content: "Radnik će za Poslodavca obavljati poslove na radnom mjestu " },
                { type: "input", value: "", required: true, help: "Unijeti naziv radnog mjesta." },
              ]
            },
            {
              parts: [
                { type: "text", content: "Radnik će za Poslodavca obavljati poslove na radnom mjestu " },
                { type: "input", value: "", required: true, help: "Unijeti naziv radnog mjesta." },
                { type: "text", content: ", kao i sve druge poslove po neposrednom nalogu Poslodavca." },
              ]
            },
            {
              parts: [
                { type: "text", content: "Radnik će za Poslodavca obavljati poslove na radnom mjestu " },
                { type: "input", value: "", required: true, help: "Unijeti naziv radnog mjesta." },
                { type: "text", content: ", a koji poslovi uključuju sljedeće zadatke i odgovornosti:" },
                { type: "textarea", value: "", required: true, help: "Upisati opis radnog mjesta - zadatke i odgovornosti." },
              ]
            }],
          value: "",
        }
      ]
    },
    {
      title: "MJESTO RADA",
      mandatory: true,
      statements: [{
        type: "choice",
        mandatory: true,
        editable: false,
        choices: [
          {
            parts: [
              { type: "text", content: "Radnik će poslove koji su predmet ovog Ugovora obavljati u sjedištu Poslodavca, a po potrebi i na drugim mjestima gdje Poslodavac obavlja svoje poslovanje i ima svoje ispostave." },
            ]
          },
          {
            parts: [
              { type: "text", content: "Radnik će poslove koji su predmet ovog Ugovora obavljati u " },
              { type: "input", value: "", required: true },
              { type: "text", content: ", a po potrebi i na drugim mjestima gdje Poslodavac obavlja svoje poslovanje i ima svoje ispostave." },
            ]
          },
          {
            parts: [
              { type: "text", content: "Radnik će poslove koji su predmet ovog Ugovora obavljati na različitim mjestima." },
            ]
          },],
        value: "",
      }]
    },
    {
      title: "POČETAK RADA",
      mandatory: true,
      statements: [
        {
          type: "input",
          mandatory: true,
          parts: [
            { type: "text", content: "Radnik će početi s radom dana " },
            { type: "input", value: "", required: true, help: "Prijava radnika tijelima mirovinskog osiguranja mora biti obavljena prije početka rada, stoga se predlaže da datum sklapanja ugovora bude prije datuma početka rada." },
            { type: "text", content: "godine. " }],
        }
      ]
    },
    {
      title: "TRAJANJE REDOVITOG RADNOG TJEDNA/DANA",
        mandatory: true,
        statements: [
          {
            type: "input",
            mandatory: true,
            editable: false,
            parts: [
              { type: "text", content: "Radnik zasniva radni odnos s Poslodavcem za radno vrijeme u dopunskom radu u trajanju od" },
              { type: "input", value: "", required: true, help: "Zakonom o radu je ograničeno trajanje dopunskog rada do najviše 8 sati tjedno." },
              { type: "text", content: "sati tjedno.",  }],
          }
        ]
      },
    {
      title: "RASPORED RADNOG VREMENA",
      mandatory: false,
      statements: [
        {
          type: "choice",
          mandatory: true,
          editable: false,
          choices: [
            {
              parts: [
                { type: "text", content: "Radno vrijeme je jednokratno te je raspoređeno u" },
                { type: "input", value: "", required: true },
                { type: "text", content: "dana u tjednu te svakim danom počinje u" },
                { type: "input", value: "", required: true },
                { type: "text", content: "sati, a završava u" },
                { type: "input", value: "", required: true },
                { type: "text", content: "sati, osim ako se odlukom o rasporedu radnog vremena ne odredi drugačije.", help: "Raspored radnog vremena utvrđuje se propisom, kolektivnim ugovorom, sporazumom sklopljenim između radničkog vijeća i poslodavca, pravilnikom o radu ili ugovorom o radu. Ako raspored radnog vremena nije utvrđen na prethodno opisani način, o rasporedu radnog vremena odlučuje poslodavac pisanom odlukom." },
              ]
            },
            {
              parts: [
                { type: "text", content: "Raspored radnog vremena određen je posebnom Odlukom Poslodavca." },
              ]
            }],
          value: "",
        }
      ]
    },
    {
      title: "STANKA, DNEVNI I TJEDNI ODMOR",
      mandatory: false,
      statements: [
        {
          type: "choice",
          mandatory: true,
          editable: true,
          choices: [
            "Radnik će koristiti stanku, dnevni odmor i tjedni odmor sukladno Zakonu o radu i Pravilniku o radu.",
            "Pravo radnika na stanku, dnevni i tjedni odmor određeno je posebnom Odlukom Poslodavca.",
            "Radnik će imati pravo na stanku od 30 minuta dnevno, a dnevni i tjedni odmor će koristiti subotom i nedjeljom."
          ],
          placeholder: "Odaberite ovdje te potom izmijenite po želji...",
        }]
    },
    {
      title: "GODIŠNJI ODMOR",
      mandatory: true,
      statements: [
        {
          type: "text",
          mandatory: true,
          editable: false,
          content: "Radnik ima pravo na godišnji odmor sukladno važećim odredbama Zakona o radu i Pravilnika o radu.",
        },
        {
          type: "text",
          mandatory: true,
          editable: false,
          content: "\r\nZa vrijeme korištenja godišnjeg odmora, Radnik ima pravo na naknadu plaće, najmanje u visini njegove prosječne mjesečne plaće u prethodna tri mjeseca.",
        },
      ]
    },
    {
      title: "OTKAZ UGOVORA",
      mandatory: true,
      statements: [
        {
          type: "text",
          mandatory: true,
          editable: true,
          content: "Ugovorne strane mogu ovaj Ugovor o radu redovito otkazati sukladno važećim odredbama Zakona o radu i Pravilnika o radu.",
        },
      ]
    },
    {
      title: "PLAĆA I DODACI NA PLAĆU",
      mandatory: false,
      statements: [
        {
          type: "choice",
          mandatory: true,
          editable: false,
          choices: [
            {
              parts: [
                { type: "text", content: "Za obavljanje poslova iz ovog Ugovora, Poslodavac će Radniku osnovnu plaću i dodatke na plaću isplaćivati sukladno odredbama Pravilnika o radu odnosno pravilnika koji regulira visinu plaće. " },
                { help: "Radniku se ne smije isplatiti plaća manja od minimalne plaće. Minimalna plaća je najniži mjesečni iznos bruto plaće koji radniku pripada za rad u punom radnom vremenu. Visinu minimalne plaće uredbom utvrđuje Vlada Republike Hrvatske, na prijedlog ministra nadležnog za rad. Pod bruto plaćom se podrazumijeva bruto 1 iznos. Poslodavac koji zapošljava najmanje dvadeset radnika dužan je donijeti i objaviti pravilnik o radu kojim se uređuju plaće (koji sadržava i postotke povećanja za noćni rad, prekovremeni rad i sl.) te se u tom smislu navodi naziv spomenutog dokumenta koji može biti i posebno donesen uz pravilnik o radu." }, 
              ]
            },
            {
              parts: [
                { type: "text", content: "Za obavljanje poslova iz ovog Ugovora, Poslodavac će Radniku isplaćivati osnovnu plaću u iznosu od najmanje " },
                { type: "input", value: "", required: true },
                { type: "text", content: "kuna bruto,", help: "Radniku se ne smije isplatiti plaća manja od minimalne plaće. Minimalna plaća je najniži mjesečni iznos bruto plaće koji radniku pripada za rad u punom radnom vremenu. Visinu minimalne plaće uredbom utvrđuje Vlada Republike Hrvatske, na prijedlog ministra nadležnog za rad. Pod bruto plaćom se podrazumijeva bruto 1 iznos." },
                { type: "text", content: "kao i dodatke na plaću sukladno Pravilniku o radu.", },
                { help: "Poslodavac koji zapošljava najmanje dvadeset radnika dužan je donijeti i objaviti pravilnik o radu kojim se uređuju plaće (koji sadržava i postotke povećanja za noćni rad, prekovremeni rad i sl.) te se u tom smislu navodi naziv spomenutog dokumenta koji može biti i posebno donesen uz pravilnik o radu."  },    
              ]
            },
          ],
          value: "",
        }
      ]
    },
    {
      title: "RAZDOBLJE ISPLATE PLAĆE",
      mandatory: true,
      statements: [
        {
          type: "choice",
          mandatory: true,
          editable: false,
          choices: [
            {
              parts: [
                { type: "text", content: "Poslodavac će isplaćivati plaću te eventualna ostala primanja na koja Radnik ima pravo u razdobljima isplate određenim Pravilnikom o radu." }
              ]
            },
            {
              parts: [
                { type: "text", content: "Poslodavac će isplaćivati plaću te eventualna ostala primanja na koja Radnik ima pravo, jednom mjesečno i to najkasnije do zadnjeg dana tekućeg mjeseca za prethodni mjesec." },
              ]
            },
            {
              parts: [
                { type: "text", content: "Poslodavac će isplaćivati plaću te eventualna ostala primanja na koja Radnik ima pravo, jednom mjesečno i to najkasnije do " },
                { type: "input", value: "", required: true },
                { type: "text", content: "–og dana u mjesecu za prethodni mjesec." },
              ]
            },
          ],
          value: "",
        }
      ]
    },
    {
      title: "UPOZNAVANJE S ORGANIZACIJOM RADA",
      mandatory: true,
      statements: [
        {
          type: "text",
          mandatory: true,
          editable: false,
          content: "Radnik svojim potpisom potvrđuje da mu je Poslodavac omogućio da se upozna s propisima u vezi s radnim odnosima  te da ga je upoznao s organizacijom rada i zaštitom zdravlja i sigurnosti na radu.",
          help: "Prema Zakonu o radu, prije stupanja Radnika na rad, poslodavac je dužan omogućiti Radniku da se upozna s propisima u vezi s radnim odnosima te ga je dužan upoznati s organizacijom rada i zaštitom zdravlja i sigurnosti na radu."
        },
      ]
    },
    {
      title: "OBVEZE RADNIKA",
      mandatory: false,
      statements: [
        {
          type: "text",
          mandatory: true,
          required: true,
          editable: true,
          content: "Radnik se obvezuje prilikom izvršavanja obveza i prava koji proizlaze iz ovog Ugovora postupati savjesno, odgovorno i stručno, sukladno naravi i vrsti posla, zakonskim i podzakonskim propisima i pravilima struke te s pažnjom dobrog gospodarstvenika, odano i vjerno zastupati interese Poslodavca odnosno čuvati i promicati njegov poslovni ugled.",
        },
      ]
    },
    {
      title: "ZAŠTITA OSOBNIH PODATAKA - GDPR",
      mandatory: false,
      statements: [
        {
          type: "text",
          mandatory: true,
          editable: true,
          help: "Primjer dokumenta kojim poslodavac, u trenutku prikupljanja podataka informira radnika u skladu s Općom uredbom o zaštiti podataka, možete vidjeti u grupi dokumenata GDPR, pod nazivom Informacije kod prikupljanja podataka.",
          content: "Poslodavac prikuplja, obrađuje i koristi osobne podatke Radnika radi ostvarivanja prava i obveza iz radnog odnosa odnosno u vezi s radnim odnosom, u skladu sa Zakonom o radu, drugim zakonima i podzakonskim aktima te Pravilnikom o radu. \r\nRadnik svojim potpisom na ovom Ugovoru potvrđuje da je od strane Poslodavca obaviješten o tome da je pružanje nekih/svih osobnih podataka koji se odnose na:\r\n- ime i prezime,\r\n- adresu, \r\n- osobni identifikacijski broj i/ili drugi identifikacijski broj,\r\n- datum rođenja / JMBG, \r\n- osobni broj iz e-radne knjižice,\r\n- broj tekućeg ili žiro-računa,\r\n- dokaz o završenom školovanju (svjedodžba, diploma i sl.), \r\n- uvjerenje o zdravstvenoj sposobnosti i sl.,\r\npreduvjet za sklapanje i izvršenje Ugovora o radu odnosno svih obveza iz radnog odnosa te je navedene podatke u tom smislu Radnik pružio Poslodavcu, a u slučaju odbijanja davanja takvih osobnih podataka, Radnik ne bi mogao biti prijavljen na obvezna osiguranja odnosno ostvariti svoja ostala prava iz radnog odnosa. \r\nOsim toga, Radnik svojim potpisom na ovom Ugovoru potvrđuje da mu je Poslodavac dostavio informacije koje je dužan dostaviti u trenutku prikupljanja gore navedenih osobnih podataka, a prema Općoj uredbi o zaštiti podataka i to:\r\n- identitet i kontaktne podatke voditelja obrade odnosno predstavnika voditelja obrade, \r\n- svrhe obrade radi kojih se upotrebljavaju osobni podaci, kao i pravnu osnovu za obradu, \r\n- primatelje ili kategorije primatelja osobnih podataka, \r\n- razdoblje u kojem će osobni podaci biti pohranjeni ili, ako to nije moguće, kriterije kojima se utvrdilo to razdoblje, \r\n- postojanje prava da se od voditelja obrade zatraži pristup osobnim podacima i ispravak ili brisanje osobnih podataka ili ograničavanje obrade koji se odnose na ispitanika ili prava na ulaganje prigovora na obradu takvih te prava na prenosivost podataka, \r\n- pravo na podnošenje prigovora nadzornom tijelu (Agencija za zaštitu osobnih podataka). \r\nU tom smislu, Radnik svojim potpisom potvrđuje da mu je u trenutku prikupljanju osobnih podataka Poslodavac pružio gore navedene informacije na način da je Radniku omogućen uvid u dokument: Informacije kod prikupljanja osobnih podataka.\r\nOsim podataka koji se obrađuju u skladu s prethodnim odredbama ovog članka, Poslodavac može prikupljati i obrađivati i druge osobne podatke Radnika, ali u tom slučaju za takvu obradu mora od Radnika dobiti izričitu i jasnu privolu.\r\nAko se obrada osobnih podataka Radnika temelji na privoli, Radnik može u bilo kojem trenutku povući takvu privolu sukladno Općoj uredbi o zaštiti osobnih podataka. ",
        },
      ]
    },
    {
      title: "PODACI O SLUŽBENIKU ZA ZAŠTITU OSOBNIH PODATAKA",
      mandatory: false,
      exampleContent: true,
      statements: [
        {
          type: "text",
          mandatory: true,
          editable: true,
          help: "Ovaj stavak upisujete u slučaju da je poslodavac imenovao službenika za zaštitu osobnih podataka. Slučajevi u kojima je imenovanje službenika za zaštitu podataka obvezno propisani su Općom uredbom o zaštiti podataka.",
          content: "Osim toga, Poslodavac je Radniku dostavio i kontaktne podatke službenika za zaštitu osobnih podataka.",
        },
      ]
    },
    {
      title: "ZAVRŠNE ODREDBE",
      mandatory: false,
      statements: [
        {
          type: "text",
          mandatory: true,
          requried: true,
          editable: true,
          content: `Ovaj Ugovor se primjenjuje od dana potpisivanja.\r\nIzmjene i dopune ovog Ugovora moraju biti u pisanom obliku.\r\nEventualne sporove nastale u vezi s Ugovorom, Poslodavac i Radnik pokušati će riješiti sporazumno, u protivnom, nadležan je stvarno nadležni sud prema sjedištu Poslodavca.`,
        }]
    },
    {
      title: 'PRIMJERCI UGOVORA',
      mandatory: false,
      statements: [
          {
              type: 'text',
              required: false,
              mandatory: true,
              editable: true,
              content: 'Ovaj Ugovor sastavljen je u 2 (dva) primjerka, od kojih svaka ugovorna strana zadržava po 1 (jedan) primjerak.',
              value: '',
          }],
    },
  {
    mandatory: true,
    static: true,
    type: 2, // date and place
    statements: [
      {
        type: "input",
        mandatory: true,
        parts: [
          {
            type: "text",
            content: "U"
          },
          {
            type: "input",
            value: "",
            placeholder: "Upišite mjesto.",
            required: true,
          },
          {
            type: "text",
            content: ", dana"
          },
          {
            type: "date",
            value: new Date(),
            required: true
          },
          {
            type: "text",
            content: "godine."
          }
        ]
      },
    ]
  },
    {
      mandatory: true,
      static: true,
      type: 3,  // signatures
      statements: [],
    }
  ],
};



// WEBPACK FOOTER //
// C:/Projects/milic/self-legal/src/app/contracts/5.3._ugovor_dopunski_rad_pravilnik.ts